import isEqualShallow from './is-equal-shallow';

interface Enum {
  [key: string]: any;
}

interface Constructor {
  new(...args: any[]): any;
  [key: string]: any;
}

export function getEnumValue(clazz: Enum | Constructor, key: string): string {
  return clazz[key] || null;
}

function isValidObject(enumerator: Enum | Constructor, value: any): boolean {
  return Object.values(enumerator).some((enumValue) =>
    isEqualShallow(enumValue, value)
  );
}

export function isEnumValid(enumerator: Enum | Constructor, value: any): boolean {
  if (value instanceof Object) {
    return isValidObject(enumerator, value);
  }

  return Object.values(enumerator).some((enumValue) => enumValue === value);
}

export function keys(clazz: Enum | Constructor): string[] {
  const keys = Object.keys(clazz);
  const isObjects = keys.some(k => clazz[k] instanceof Object);

  return isObjects ? keys.concat(keys.map(k => clazz[k].key)) : keys;
}

export function props(clazz: Enum | Constructor, prop: string): any[] {
  return Object.values(clazz).map(v => v[prop]);
}

export function enumValues(clazz: Enum | Constructor): string[] {
  return Object.keys(clazz).filter(k => k === k.toUpperCase()).map(k => clazz[k]);
}

export function valueOf(clazz: Enum | Constructor, key: string | object): object | string {
  if (typeof key === 'object') {
    return key;
  }

  const value = getEnumValue(clazz, key);

  if (!value) {
    return enumValues(clazz).filter((val: any) => {
      const isObject = val instanceof Object;
      if (isObject && val.key === key) {
        return val;
      }
    });
  }

  return value;
}

export default {
  get: getEnumValue,
  isEnumValid,
  keys,
  props,
  valueOf,
  enumValues,
};
